import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from '../../../hooks/useFetch';
import { AuthContext } from '../../../contexts/AuthContext';
import UserService from '../../../services/user.service';
import TopSection from './components/TopSection';
import BasicDetails from './components/BasicDetails';

const Profile: React.FC = () => {
  const { t } = useTranslation();
  const { loggedInUser } = useContext(AuthContext);

  const [profileDetails, setProfileDetails] = useState<any>({});

  useFetch({
    service: UserService,
    func: 'get',
    payload: loggedInUser.id,
    dependency: [loggedInUser.id],
    skip: !loggedInUser.id,
    onSuccess: async (response) => {
      setProfileDetails(response || {});
    },
    onError: (e: any) => {
      setProfileDetails({});
    },
  });

  return (
    <div className="flex-grow-1">
      <div className="row">
        <div className="col-12">
          <TopSection
            email={profileDetails.email}
            fullName={profileDetails.full_name}
            roles={profileDetails.roles}
            manager={profileDetails.manager}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-xl-6 col-lg-8">
          <BasicDetails
            email={profileDetails.email}
            firstName={profileDetails.first_name}
            lastName={profileDetails.last_name}
            active={profileDetails.is_active}
            countryCode={profileDetails.country_code}
            phoneNumber={profileDetails.phone_number}
            createdAt={profileDetails.created_at}
          />
        </div>
      </div>
    </div>
  );
};

export default Profile;
